// extracted by mini-css-extract-plugin
export default {"tabs":"hg9vS","tab":"lcjwu","active":"nzF8M","scrollBar":"YfDlh","activeBar":"kCGEt"};